import ResetFilters from './reset-filters';

export default ResetFilters;